// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modern-blog-container {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  color: #1a1a1a;
  line-height: 1.5;
}

/* Featured Post Styling */
.featured-post-wrapper {
  transition: opacity 0.3s ease;
}

.featured-image-container {
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.05);
  position: relative;
}

.featured-main-title {
  letter-spacing: -0.02em;
}

.featured-meta-info {
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

/* Grid Styling */
.blogs-modern-grid {
  margin-top: 2rem;
}

.modern-blog-card {
  display: flex;
  flex-direction: column;
}

.card-image-wrap {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.03);
  background: #f0f2f5;
}

.card-title {
  font-family: 'Playfair Display', serif;
  font-weight: 900;
  color: #000;
  transition: color 0.3s ease;
}

.modern-blog-card:hover .card-title {
  color: #3b82f6;
}

.read-time-badge {
  color: #888;
}

.card-desc {
  letter-spacing: 0.05em;
  color: #555;
  font-size: 0.75rem;
}

/* Numerical Pagination */
.pagination-number {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-weight: 800;
  font-size: 0.85rem;
  color: #000;
  background: white;
  border: 1px solid #eee;
  transition: all 0.3s ease;
}

.pagination-number:hover {
  border-color: #3b82f6;
  color: #3b82f6;
}

.pagination-number.active {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.pagination-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 50%;
  transition: background 0.2s ease;
}

/* Sections */
.section-heading {
  letter-spacing: -0.01em;
}

/* Newsletter Customization */
.modern-blog-container .newsletter-signup {
  background: transparent !important;
  padding: 0 !important;
  box-shadow: none !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .featured-main-title {
    font-size: 2.25rem !important;
  }
  
  .featured-image-container img {
    height: 300px !important;
  }
  
  .blogs-modern-grid {
    gap-y: 12px;
  }
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.animate-fadeIn {
  animation: fadeIn 0.8s ease forwards;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Blog.css"],"names":[],"mappings":"AAEA;EACE,mEAAmE;EACnE,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,aAAa;AACb;EACE,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,kCAAkC;EAClC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,eAAe;AACf;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap');\n\n.modern-blog-container {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n  color: #1a1a1a;\n  line-height: 1.5;\n}\n\n/* Featured Post Styling */\n.featured-post-wrapper {\n  transition: opacity 0.3s ease;\n}\n\n.featured-image-container {\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.05);\n  position: relative;\n}\n\n.featured-main-title {\n  letter-spacing: -0.02em;\n}\n\n.featured-meta-info {\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n/* Grid Styling */\n.blogs-modern-grid {\n  margin-top: 2rem;\n}\n\n.modern-blog-card {\n  display: flex;\n  flex-direction: column;\n}\n\n.card-image-wrap {\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.03);\n  background: #f0f2f5;\n}\n\n.card-title {\n  font-family: 'Playfair Display', serif;\n  font-weight: 900;\n  color: #000;\n  transition: color 0.3s ease;\n}\n\n.modern-blog-card:hover .card-title {\n  color: #3b82f6;\n}\n\n.read-time-badge {\n  color: #888;\n}\n\n.card-desc {\n  letter-spacing: 0.05em;\n  color: #555;\n  font-size: 0.75rem;\n}\n\n/* Numerical Pagination */\n.pagination-number {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  font-weight: 800;\n  font-size: 0.85rem;\n  color: #000;\n  background: white;\n  border: 1px solid #eee;\n  transition: all 0.3s ease;\n}\n\n.pagination-number:hover {\n  border-color: #3b82f6;\n  color: #3b82f6;\n}\n\n.pagination-number.active {\n  background: #3b82f6;\n  color: white;\n  border-color: #3b82f6;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.pagination-arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  border-radius: 50%;\n  transition: background 0.2s ease;\n}\n\n/* Sections */\n.section-heading {\n  letter-spacing: -0.01em;\n}\n\n/* Newsletter Customization */\n.modern-blog-container .newsletter-signup {\n  background: transparent !important;\n  padding: 0 !important;\n  box-shadow: none !important;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .featured-main-title {\n    font-size: 2.25rem !important;\n  }\n  \n  .featured-image-container img {\n    height: 300px !important;\n  }\n  \n  .blogs-modern-grid {\n    gap-y: 12px;\n  }\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.animate-fadeIn {\n  animation: fadeIn 0.8s ease forwards;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
